import {TimelineMax, Circ} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const MousemoveParallax = require('../utils/MousemoveParallax');

const _addView = (instance, config) => {
    const contFront = new PIXI.Container();
    const contBack = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');

    const bgImg = Shortcuts.getSprite('galleryBg', TextureCache, 'bgImg');
    const bg = new PIXI.Container();
    bgImg.anchor.set(0.5, 0);
    bg.addChild(bgImg);
    bg.position.set(sizes.width * 0.5, 0);
    bg.z = -0.5;

    const picBackCenterImg = Shortcuts.getSprite('gallery_picBackCenter', TextureCache, 'picBackCenterImg');
    const picBackCenter = new PIXI.Container();
    picBackCenterImg.anchor.set(0.5, 0);
    picBackCenter.addChild(picBackCenterImg);
    picBackCenter.position.set(sizes.width * 0.5, sizes.height * 0.18);
    picBackCenter.z = -0.35;

    const picBackLeftImg = Shortcuts.getSprite('gallery_picBackLeft', TextureCache, 'picBackLeftImg');
    const picBackLeft = new PIXI.Container();
    picBackLeftImg.anchor.set(1, 0);
    picBackLeft.addChild(picBackLeftImg);
    picBackLeft.position.set(sizes.width * 0.5 - picBackCenterImg.width * 0.57, sizes.height * 0.23);

    const picBackRightImg = Shortcuts.getSprite('gallery_picBackRight', TextureCache, 'picBackRightImg');
    const picBackRight = new PIXI.Container();
    picBackRightImg.anchor.set(0, 0);
    picBackRight.addChild(picBackRightImg);
    picBackRight.position.set(sizes.width * 0.5 + picBackCenterImg.width * 0.57, sizes.height * 0.28);
    picBackRight.z = picBackLeft.z = -0.3;

    const picFrontCenterImg = Shortcuts.getSprite('gallery_picFrontCenter', TextureCache, 'picFrontCenterImg');
    const picFrontCenter = new PIXI.Container();
    picFrontCenterImg.anchor.set(0.5, 0.5);
    picFrontCenter.addChild(picFrontCenterImg);
    picFrontCenter.position.set(sizes.width * 0.47, sizes.height * 0.66);
    picFrontCenter.z = 1.5;

    const picFrontLeftImg = Shortcuts.getSprite('gallery_picFrontLeft', TextureCache, 'picFrontLeftImg');
    const picFrontLeft = new PIXI.Container();
    picFrontLeftImg.anchor.set(0.5, 0.5);
    picFrontLeft.addChild(picFrontLeftImg);
    picFrontLeft.position.set(sizes.width * 0.21, sizes.height * 0.65);
    picFrontLeft.z = 3;

    const picFrontRightImg = Shortcuts.getSprite('gallery_picFrontRight', TextureCache, 'picFrontRightImg');
    const picFrontRight = new PIXI.Container();
    picFrontRightImg.anchor.set(0.5, 0.5);
    picFrontRight.addChild(picFrontRightImg);
    picFrontRight.position.set(sizes.width * 0.9, sizes.height * 0.69);
    picFrontRight.z = 2;

    /* const pBlur = new PIXI.filters.BlurFilter(10);
    picBackCenter.filters = [pBlur];*/

    const overlay = new PIXI.Graphics();
    Shortcuts.rect(overlay, 0, 0, sizes.width, sizes.height, config.overlayColor !== void 0 ? config.overlayColor : 0x0b0b0f);

    overlay.alpha =
    bg.alpha =
    picBackCenter.alpha =
    picBackLeft.alpha =
    picBackRight.alpha =
    picFrontCenter.alpha =
    picFrontRight.alpha =
    picFrontLeft.alpha = 0;

    contBack.addChild(bg);
    contBack.addChild(picBackCenter);
    contBack.addChild(picBackLeft);
    contBack.addChild(picBackRight);

    contFront.addChild(picFrontCenter);
    contFront.addChild(picFrontRight);
    contFront.addChild(picFrontLeft);

    contFront.addChild(overlay);

    instance.contFront = contFront;
    instance.contBack = contBack;
    instance.width = sizes.width;
    instance.height = sizes.height;
    instance.bg = bg;
    instance.bgImg = bgImg;
    instance.picBackCenter = picBackCenter;
    instance.picBackCenterImg = picBackCenterImg;
    instance.picBackLeft = picBackLeft;
    instance.picBackLeftImg = picBackLeftImg;
    instance.picBackRight = picBackRight;
    instance.picBackRightImg = picBackRightImg;
    instance.picFrontCenter = picFrontCenter;
    instance.picFrontCenterImg = picFrontCenterImg;
    instance.picFrontRight = picFrontRight;
    instance.picFrontRightImg = picFrontRightImg;
    instance.picFrontLeft = picFrontLeft;
    instance.picFrontLeftImg = picFrontLeftImg;
    // instance.pBlur = pBlur;
    instance.overlay = overlay;
    instance.overlayOn = 0;
    instance.parallaxLayers = [bg, picBackCenter, picBackLeft, picBackRight, picFrontCenter, picFrontRight, picFrontLeft];

    if (config.overAll) {
        instance.rootFront.addChild(contFront);
        instance.rootBack.addChild(contBack);
    } else {
        instance.rootFront.addChildAt(contFront, 0);
        instance.rootBack.addChildAt(contBack, 0);
    }


}

const _removeView = instance => {
    if (instance.contFront.parent)
        instance.contFront.parent.removeChild(instance.contFront);
    if (instance.contBack.parent)
        instance.contBack.parent.removeChild(instance.contBack);
}

const _constructTimeline = (instance, config) => {
    const tl = new TimelineMax({paused: true});

    // PICS
    tl.set([instance.bg, instance.picBackCenter, instance.picBackLeft, instance.picBackRight, instance.picFrontCenter, instance.picFrontRight, instance.picFrontLeft], {alpha: 0}, 'set');

    // BG
    tl.set(instance.bg.scale, {x: 0.5, y: 0.5}, 'set');

    tl.to(instance.bg, config.idleDuration, {alpha: 1}, 'set');
    tl.to(instance.bg.scale, config.idleDuration, {x: 1, y: 1}, 'set');

    // picBackCenter
    tl.set(instance.picBackCenter.scale, {x: 0.65, y: 0.65}, 'set');
    tl.set(instance.picBackCenter.position, {x: instance.width * 0.5, y: instance.height * 0.18 * 0.64}, 'set');

    tl.to(instance.picBackCenter, config.idleDuration * 0.6, {alpha: 1}, 'set');
    tl.to(instance.picBackCenter.scale, config.idleDuration, {x: 1, y: 1}, 'set');
    tl.to(instance.picBackCenter.position, config.idleDuration, {x: instance.width * 0.5, y: instance.height * 0.18}, 'set');

    // picBackLeft
    tl.set(instance.picBackLeft.scale, {x: 0.7, y: 0.75}, 'set');
    tl.set(instance.picBackLeft.position, {x: instance.width * 0.5 - instance.picBackCenterImg.width * 0.57 * 0.7, y: instance.height * 0.23 * 0.7}, 'set');

    tl.to(instance.picBackLeft, config.idleDuration * 0.5, {alpha: 1}, 'set');
    tl.to(instance.picBackLeft.scale, config.idleDuration, {x: 1, y: 1}, 'set');
    tl.to(instance.picBackLeft.position, config.idleDuration, {x: instance.width * 0.5 - instance.picBackCenterImg.width * 0.57, y: instance.height * 0.23}, 'set');

    // picBackRight
    tl.set(instance.picBackRight.scale, {x: 0.7, y: 0.75}, 'set');
    tl.set(instance.picBackRight.position, {x: instance.width * 0.5 + instance.picBackCenterImg.width * 0.57 * 0.7, y: instance.height * 0.28 * 0.7}, 'set');

    tl.to(instance.picBackRight, config.idleDuration * 0.5, {alpha: 1}, 'set');
    tl.to(instance.picBackRight.scale, config.idleDuration, {x: 1, y: 1}, 'set');
    tl.to(instance.picBackRight.position, config.idleDuration, {x: instance.width * 0.5 + instance.picBackCenterImg.width * 0.57, y: instance.height * 0.28}, 'set');

    // picFrontCenter
    tl.set(instance.picFrontCenter.scale, {x: 5, y: 5}, 'set');
    tl.set(instance.picFrontCenter.position, {x: instance.width * (0.47 - 1), y: instance.height * 0.75}, 'set');

    tl.to(instance.picFrontCenter, config.idleDuration * 0.2, {alpha: 1}, 'set');
    tl.to(instance.picFrontCenter.scale, config.idleDuration * 0.8, {x: 1, y: 1}, 'set');
    tl.to(instance.picFrontCenter.position, config.idleDuration * 0.8, {x: instance.width * 0.47, y: instance.height * 0.66, ease: Circ.easeOut}, 'set');

    // picFrontLeft
    tl.set(instance.picFrontLeft.scale, {x: 8, y: 8}, 'set');
    tl.set(instance.picFrontLeft.position, {x: instance.width * (0.21 - 3), y: instance.height * 0.45}, 'set');

    tl.to(instance.picFrontLeft, config.idleDuration * 0.2, {alpha: 1}, 'set');
    tl.to(instance.picFrontLeft.scale, config.idleDuration * 0.8, {x: 1, y: 1}, 'set');
    tl.to(instance.picFrontLeft.position, config.idleDuration * 0.8, {x: instance.width * 0.21, y: instance.height * 0.65, ease: Circ.easeOut}, 'set');

    // picFrontRight
    tl.set(instance.picFrontRight.scale, {x: 9, y: 9}, 'set');
    tl.set(instance.picFrontRight.position, {x: instance.width * (0.9 + 2.5), y: instance.height * 0.5}, 'set');

    tl.to(instance.picFrontRight, config.idleDuration * 0.2, {alpha: 1}, 'set');
    tl.to(instance.picFrontRight.scale, config.idleDuration * 0.8, {x: 1, y: 1}, 'set');
    tl.to(instance.picFrontRight.position, config.idleDuration * 0.8, {x: instance.width * 0.9, y: instance.height * 0.69, ease: Circ.easeOut}, 'set');

    // OVERLAY
    tl.set(instance.overlay, {alpha: 0}, 'set');
    tl.set(instance, {overlayOn: 0}, 'set');
    tl.to(instance.overlay, config.idleDuration, {alpha: 0}, 'set');
    tl.to(instance.overlay, config.transitionDuration, {alpha: config.overlayOpacity || 0.67}, 'set+=' + config.idleDuration);
    tl.to(instance.overlay, config.fadeDuration - config.transitionDuration * 0.5, {alpha: config.overlayOpacity || 0.67}, 'set+=' + (config.idleDuration + config.transitionDuration));
    tl.to(instance.overlay, config.transitionDuration * 0.5 - 0.05, {alpha: 1}, 'set+=' + (config.idleDuration + config.fadeDuration));

    tl.to([instance.bg, instance.picBackCenter, instance.picBackLeft, instance.picBackRight, instance.picFrontCenter, instance.picFrontRight, instance.picFrontLeft, instance.overlay], 0, {alpha: 0}, 'off');
    tl.to(instance, 0, {overlayOn: 0}, 'off');


    instance.timeline = tl;
    return tl;
}

function GalleryTimeline(app, rootFront, rootBack, config) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            rootFront: rootFront,
            rootBack: rootBack
        };
        _addView(instance, config);

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance'], config);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = config.idleDuration + config.transitionDuration;
    constructor.totalDuration = config.idleDuration + config.transitionDuration + config.fadeDuration;

    return constructor;
}

module.exports = GalleryTimeline;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/GalleryTimeline.js